import { AxiosResponse } from 'axios';
import { ResponseInterceptor } from '../Interceptor';
import { ResponseLogConfig } from 'axios-logger/lib/common/types';
import * as AxiosLogger from 'axios-logger';

const responseLoggerConfig: ResponseLogConfig = {
  headers: false,
  data: false,
  status: true,
  statusText: true,
};

export class ResponseLoggingInterceptor implements ResponseInterceptor {
  async onFulfilled(config: AxiosResponse): Promise<AxiosResponse> {
    return AxiosLogger.responseLogger(config, responseLoggerConfig);
  }

  onRejected(error: any): any {
    return AxiosLogger.errorLogger(error);
  }
}
